import { render, staticRenderFns } from "./IntegratedStorageClassView.vue?vue&type=template&id=278796ba&scoped=true&"
import script from "./IntegratedStorageClassView.vue?vue&type=script&lang=js&"
export * from "./IntegratedStorageClassView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278796ba",
  null
  
)

export default component.exports